import PremiumContentModal from "components/PremiumContentModal";
import LiveTvChannelChangeIcon from "components/shared/LiveTvChannelChangeIcon";
import { RouteName } from "constant/routeNames";
import usePremiumAccess from "hooks/usePremiumAccess";
import { useEffect, useState } from "react";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearLockedChannel,
  setCurrentChannelId,
  setLiveTVSuccess,
  setLockedChannel,
  setVideoStart,
} from "redux/VideoPlayerRedux";
import { ContentType } from "services/subscription/types";

const YouAreWatching = ({ currentLiveTv, dataList }: any) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { channelId } = useSelector((state: any) => state?.video);
  const { isModalOpen, setIsModalOpen, checkAccess } = usePremiumAccess();
  const displayedChannel = dataList?.[channelId] ?? currentLiveTv;

  useEffect(() => {
    const foundIndex = dataList.findIndex(
      (c: any) => currentLiveTv?.id === c?.id,
    );

    if (foundIndex >= 0) {
      dispatch(setCurrentChannelId(foundIndex));
    }
  }, [currentLiveTv, dataList]);

  const clickNavigation = async (text: string) => {
    if (text === "Down") {
      if (channelId !== 0) {
        let newId: any = channelId - 1;
        await channelChange(newId);
      }
    } else {
      if (channelId <= dataList?.length) {
        let newId: any = channelId + 1;
        await channelChange(newId);
      }
    }
  };

  const channelChange = async (newId: any) => {
    const nextChannel = dataList[newId];
    const isPremiumContent = nextChannel?.plan_id === 2;

    // Move the pointer first so the name/position updates and further
    // Up/Down clicks keep progressing even if this channel is locked.
    await dispatch(setCurrentChannelId(newId));

    const access = await checkAccess({
      contentType: ContentType.TV_CHANNELS,
      id: nextChannel?.id,
      isPremiumContent,
      isCreator: false,
    });
    if (!access) {
      await dispatch(setLockedChannel(nextChannel));
      return;
    }

    await dispatch(clearLockedChannel());
    await dispatch(setVideoStart());
    await dispatch(setLiveTVSuccess(dataList[newId]));
    navigate(
      RouteName.LiveTVPlayerLinkWithSlug.replace(
        ":slug",
        dataList[newId]?.slug,
      ),
    );
  };

  return (
    <>
      <PremiumContentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreator={false}
      />
      <div className="flex flex-col justify-center cursor-default">
        <p className="mb-1 text-sm flex text-center justify-center Color7B9DB4 max-md-text-[20px]">
          You're now watching
        </p>
        <div className="flex items-center justify-center max-sm:justify-between">
          <LiveTvChannelChangeIcon
            Icon={BiSolidDownArrow}
            text="Down"
            changeChannel={clickNavigation}
            disabled={channelId === 0}
          />
          <div className="flex flex-col items-center justify-center  cursor-default max-sm:w-[45%]  max-sm:mx-auto ">
            <h1
              className={`flex items-center w-auto px-4 py-1 text-center text-white rounded-full border border-red-500 max-sm:p-2  max-sm:text-[15px] max-sm:w-[full] max-sm:px-6 max-sm:my-2  `}
            >
              {displayedChannel && displayedChannel.name}
            </h1>
          </div>
          <LiveTvChannelChangeIcon
            Icon={BiSolidUpArrow}
            text="Up"
            changeChannel={clickNavigation}
            disabled={channelId === dataList.length - 1}
          />
        </div>
      </div>
    </>
  );
};

export default YouAreWatching;
